import {inject} from "@angular/core";
import {HttpHeaders, HttpInterceptorFn} from '@angular/common/http';

import {AccessTokenService} from "@numizmat/services/account";

export const accessTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const accessTokenService: AccessTokenService = inject(AccessTokenService);
  const accessToken = accessTokenService.getAccessToken();

  if (!!accessToken) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + accessToken
    });
    req = req.clone({
      headers: headers
    });
  }

  return next(req);
};
